import React, { ReactNode } from 'react';
import './PaneSection.pcss';
import classnames from 'classnames';
import { HelpLink } from '../HelpLink/HelpLink';

type Props = {
  title?: string | ReactNode | Element[];
  children: any;
  headerRightSection?: any;
  className?: string;
  classNameBody?: string;
  helpHref?: string;
};

const PaneSection = (props: Props) => {
  const {
    children,
    title,
    className,
    classNameBody,
    headerRightSection,
    helpHref,
  } = props;
  const showHeader = title || headerRightSection;

  return (
    <div className={classnames('pane-section', className)}>
      {showHeader && (
        <div className="pane-section__header">
          <h4 className="pane-section__section-title">
            {title}
            {helpHref && (
              <HelpLink className="pane-section__help-link" href={helpHref} />
            )}
          </h4>

          {headerRightSection && headerRightSection()}
        </div>
      )}

      <div className={classnames('pane-section__body', classNameBody)}>
        {children}
      </div>
    </div>
  );
};

export default PaneSection;
